import type { PublicSlotKey } from '#packages/apilib';
import type { SectionsMigrationPublicApi } from './api';

export const SectionsMigrationApiKey: PublicSlotKey<SectionsMigrationPublicApi> =
  {
    name: 'SectionsMigrationApi',
    public: true,
  };
